"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ethereumcodec_1 = require("./ethereumcodec");
const ethereumconnection_1 = require("./ethereumconnection");
/**
 * A helper to connect to a ethereum-based chain at a given url
 *
 * @param options An EthereumConnectionOptions object. If {}, all possible options are set to their default.
 */
function createEthereumConnector(url, options, expectedChainId) {
    return {
        establishConnection: async () => ethereumconnection_1.EthereumConnection.establish(url, options),
        codec: new ethereumcodec_1.EthereumCodec({
            erc20Tokens: options.erc20Tokens,
            atomicSwapEtherContractAddress: options.atomicSwapEtherContractAddress,
            atomicSwapErc20ContractAddress: options.atomicSwapErc20ContractAddress,
            customSmartContractConfig: options.customSmartContractConfig,
        }),
        expectedChainId: expectedChainId,
    };
}
exports.createEthereumConnector = createEthereumConnector;
//# sourceMappingURL=ethereumconnector.js.map